import axios from 'axios';
import { updateCampaign } from 'src/components/AdManager/AmsUtils';

const GET_CAMPAIGN_PORTFOLIO_ID_API = 'apiAdManager/adCampaigns/getCampaignsByPortfolioIds';

class PortfolioBudgetExceededError extends Error {
  data: any;

  constructor(message, data) {
    super(message);
    this.name = 'PortfolioBudgetExceededError';
    this.data = data;
  }
}

export const getCampaignPortfolioId = async (portfolioId: string) => {
  const res = axios.get(`${GET_CAMPAIGN_PORTFOLIO_ID_API}/${portfolioId}`);
  return res;
};

export const updateCampaignPortfolio = async (campaign: any, portfolio: any) => {
  const campaignsInPortfolio = await getCampaignPortfolioId(portfolio.id);
  const cumBudget = campaignsInPortfolio.data.reduce(
    (acc, curr) => acc + curr?.extendedAttributes?.liveBudgetSetting?.amount,
    0
  );

  if (cumBudget > portfolio.extendedAttributes?.liveBudgetSetting?.amount) {
    const data = {
      current: portfolio.extendedAttributes?.liveBudgetSetting?.amount.toFixed(1),
      new: cumBudget.toFixed(1)
    };

    throw new PortfolioBudgetExceededError('Portfolio budget exceeded', data);
  }

  const res = await updateCampaign(campaign);
  return res;
};
